<div class="account-navigation" [class.sidebar-collapsed]="sidebarCollapsed" [class.mobile-view]="isMobile">
  <!-- Mobile Header Bar -->
  <div class="mobile-header" *ngIf="isMobile">
    <img id="mobile-logo" src="../../../../assets/master-logo-white-tight.svg" />
    <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle navigation menu">
      <i class="fa-utility fa-semibold fa-bars"></i>
    </button>
  </div>

  <!-- Mobile Menu Backdrop -->
  <div class="mobile-backdrop" *ngIf="isMobile && mobileMenuOpen" (click)="closeMobileMenu()"></div>

  <!-- Sidenav -->
  <div
    class="sidenav"
    [class.collapsed]="sidebarCollapsed && !isMobile"
    [class.mobile-open]="isMobile && mobileMenuOpen"
    [class.mobile-closed]="isMobile && !mobileMenuOpen"
  >
    <div class="sidebar-header">
      <!-- Desktop header content -->
      <ng-container *ngIf="!isMobile">
        <img id="logo" src="../../../../assets/master-logo-white-tight.svg" *ngIf="!sidebarCollapsed" />
        <div class="" [ngClass]="sidebarCollapsed ? 'text-center margin-auto' : ''">
          <img class="favicon collapsed-logo" src="../../../../favicon-32x32.png" *ngIf="sidebarCollapsed" />
          <button
            class="collapse-toggle collapsed-icon-link"
            [ngClass]="sidebarCollapsed ? 'margin-auto' : ''"
            (click)="toggleSidebar()"
            [pTooltip]="sidebarCollapsed ? 'View Menu' : ''"
            tooltipPosition="right"
          >
            <i class="fa-utility fa-semibold" [ngClass]="sidebarCollapsed ? 'fa-bars' : 'fa-xmark'"></i>
          </button>
        </div>
      </ng-container>
      <!-- Mobile header content -->
      <ng-container *ngIf="isMobile">
        <img id="logo" src="../../../../assets/master-logo-white-tight.svg" />
        <button class="mobile-close-btn" (click)="closeMobileMenu()" aria-label="Close navigation menu">
          <i class="fa-utility fa-semibold fa-xmark"></i>
        </button>
      </ng-container>
    </div>

    <div class="nav-content" *ngIf="(isMobile && mobileMenuOpen) || (!isMobile && !sidebarCollapsed)" @fadeIn>
      <div *ngIf="shouldShowWelcomeLink">
        <ul>
          <li>
            <a [routerLink]="welcomeUrl" routerLinkActive="activated-route">Welcome to Arpio!</a>
          </li>
        </ul>
      </div>
      <!-- Search Filter -->
      <div class="nav-search" *ngIf="!loading">
        <div class="nav-search-field">
          <i class="fa-solid fa-magnifying-glass nav-search-icon"></i>
          <input
            type="text"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            class="nav-search-input"
            autocomplete="off"
            spellcheck="false"
          />
          <button class="nav-search-clear" *ngIf="searchTerm" (click)="clearSearch()" aria-label="Clear search">
            <i class="fa-utility fa-semibold fa-xmark"></i>
          </button>
        </div>
      </div>

      <!-- No results -->
      <div class="nav-no-results" *ngIf="isSearching && !hasAnySearchMatch">No results for "{{ searchTerm }}"</div>

      <!-- APPLICATIONS -->
      <div *ngIf="(shouldShowApplicationsSection || loading) && (!isSearching || hasApplicationsMatch)">
        <h2
          class="nav-heading collapsible"
          [ngClass]="sections.applications ? 'open' : 'collapsed'"
          (click)="sections.applications = !sections.applications"
        >
          <i class="fa-utility fa-semibold" [ngClass]="sections.applications ? 'fa-angle-down' : 'fa-angle-right'"></i>
          APPLICATIONS
        </h2>
        <ul *ngIf="sections.applications && loading" @slideDown>
          <li>
            <div class="nav-entry"><i class="fa-solid fa-spinner fa-spin"></i> Loading applications...</div>
          </li>
        </ul>
        <ul *ngIf="sections.applications && !loading" @slideDown>
          <li
            *ngIf="
              canCreateApplications && (!isSearching || applicationsSectionMatch || matchesSearch('Create New ...'))
            "
          >
            <a
              data-cy="create-application-button"
              [routerLink]="createApplicationUrl"
              routerLinkActive="activated-route"
              >+ Create New ...</a
            >
          </li>
          <li *ngFor="let application of filteredApplications | sort: 'name' : true; trackBy: applicationTrackBy">
            <div class="flex-center-row nav-entry">
              <div class="spacer">
                <a
                  [routerLink]="application.url"
                  routerLinkActive="activated-route"
                  [routerLinkActiveOptions]="{ exact: false }"
                  >{{ application.name }}</a
                >
              </div>
              <ng-container *ngIf="application?.isDeleted">
                <div class="nav-glyph deleted-app">D</div>
              </ng-container>
              <ng-container [ngSwitch]="application.syncPhase">
                <div *ngSwitchCase="'failover'" class="nav-glyph recovery-phase">R</div>
                <div *ngSwitchCase="'failoverTest'" class="nav-glyph test-phase">T</div>
                <div *ngSwitchCase="'release'" class="nav-glyph release-phase">RL</div>
              </ng-container>
            </div>
            <ul class="no-right-margin" *ngIf="application.issueCount > 0">
              <li class="no-right-margin">
                <div class="flex-center-row nav-entry">
                  <div class="spacer">
                    <a
                      [routerLink]="application.issuesUrl"
                      routerLinkActive="activated-route"
                      [routerLinkActiveOptions]="{ exact: true }"
                      >Issues</a
                    >
                  </div>
                  <div class="nav-glyph issue-count">
                    {{ application.issueCount }}
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- SETTINGS -->
      <div #settingsSection *ngIf="!isSearching || hasSettingsMatch">
        <h2
          data-cy="settings-menu"
          class="nav-heading collapsible"
          [ngClass]="sections.settings ? 'open' : 'collapsed'"
          (click)="sections.settings = !sections.settings"
        >
          <i class="fa-utility fa-semibold" [ngClass]="sections.settings ? 'fa-angle-down' : 'fa-angle-right'"></i>
          SETTINGS
        </h2>
        <ul *ngIf="sections.settings" @slideDown>
          <li *ngIf="settingsSectionMatch || accountSettingsMatch">
            <a [routerLink]="accountSettingsUrl" routerLinkActive="activated-route">Account Settings</a>
          </li>
          <li *ngIf="settingsSectionMatch || accessManagementMatch">
            <a [routerLink]="accessManagementUrl" routerLinkActive="activated-route">Access Management</a>
          </li>
          <li *ngIf="licensedForIntegrations && (settingsSectionMatch || matchesSearch('Add Ons'))">
            <a [routerLink]="integrationsUrl" routerLinkActive="activated-route">Add Ons</a>
          </li>
        </ul>
      </div>

      <!-- HELP -->
      <div #helpSection *ngIf="!isSearching || hasHelpMatch">
        <h2
          class="nav-heading collapsible"
          [ngClass]="sections.help ? 'open' : 'collapsed'"
          (click)="sections.help = !sections.help"
        >
          <i class="fa-utility fa-semibold" [ngClass]="sections.help ? 'fa-angle-down' : 'fa-angle-right'"></i>
          HELP
        </h2>
        <ul *ngIf="sections.help" @slideDown>
          <li *ngIf="helpSectionMatch || matchesSearch('Support')">
            <a [routerLink]="accountSupportUrl" routerLinkActive="activated-route">Support</a>
          </li>
          <li *ngIf="helpSectionMatch || matchesSearch('Documentation')">
            <a id="docs-link" target="_blank" [href]="uiService.documentationUrl">Documentation</a>
          </li>
        </ul>
      </div>

      <a id="logout-link" routerLink="" (click)="logoutClick()" *ngIf="!isSearching || matchesSearch('Sign Out')"
        >Sign Out &nbsp;<i class="fa-utility fa-semibold fa-arrow-right-from-bracket"></i
      ></a>
    </div>

    <!-- Collapsed sidebar icons (desktop only) -->
    <div class="collapsed-icons" *ngIf="sidebarCollapsed && !isMobile">
      <button class="collapsed-icon-link" (click)="toggleSidebar()" pTooltip="Search" tooltipPosition="right">
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
      <button
        class="collapsed-icon-link"
        (click)="expandSidebarAndSection('settings')"
        pTooltip="Settings"
        tooltipPosition="right"
      >
        <i class="fa-solid fa-gears"></i>
      </button>
      <button
        class="collapsed-icon-link"
        (click)="expandSidebarAndSection('help')"
        pTooltip="Help"
        tooltipPosition="right"
      >
        <i class="fa-utility fa-semibold fa-question"></i>
      </button>
      <a class="collapsed-icon-link" routerLink="" (click)="logoutClick()" pTooltip="Sign Out" tooltipPosition="right">
        <i class="fa-utility fa-semibold fa-arrow-right-from-bracket"></i>
      </a>
    </div>
  </div>

  <div class="main light">
    <router-outlet></router-outlet>
    <div class="loading-main-app loading-overlay" *ngIf="!readyToShowContent">
      <h1><i class="fa-solid fa-spinner fa-spin font-size-inherit"></i> Loading</h1>
    </div>
  </div>
</div>
